// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.transcript-full-div {
  width: 100%;
  height: 100%;
}

.transcript-title-div,
.transcript-search-div {
  position: sticky;
  z-index: 2;
  justify-items: right;
  padding: 5px;
  display: none;
}

.transcript-title-div {
  background-color: #404040;
  text-align: center;
}

.transcript-title-div.title-active,
.transcript-search-div.search-active {
  display: block;
}

.transcript-top-div {
  width: 100%;
  height: calc(100% - 45px);
  display: flex;
}

.transcript-full-div:has(.title-active) {
  height: calc(100% - 32px);
}
.transcript-top-div.search-active {
  height: calc(100% - 80px);
}

.transcript-full-div:has(.replace-active) .transcript-top-div.search-active {
  height: calc(100% - 110px);
}

.transcript-text-div {
  width: calc(100% - 20px);
  height: 100%;
  background-color: transparent;
  cursor: text;
  outline: none;
}

.transcript-scroll-div {
  height: 99%;
  width: 20px;
}

.transcript-bottom-div {
  width: 100%;
  height: 45px;
  background-color: #404040;
  border-top: 1px solid;
  font-size: 90%;
  align-content: center;
  overflow: hidden;
}

.transcript-bottom-div .row {
  display: flex;
  flex-direction: row;
}

.transcript-bottom-div .row .col {
  display: flex;
  flex: 50% 1;
}

.transcript-bottom-div .row .col p:first-child {
  padding: 0 5px;
}

.transcript-bottom-div .row .col:last-child {
  justify-content: right;
}

.transcript-bottom-div p {
  margin: 0;
}

.pl-5 {
  padding-left: 5px;
}

.pr-5 {
  padding-right: 5px;
}

.pink {
  color: #ff9c9c;
}

.foreCanvas {
  width: 100%;
  height: 100%;
  background-color: transparent;
  cursor: text;
}

input[type='range'][orient='vertical'] {
  writing-mode: vertical-lr;
  direction: ltr;
  width: 16px;
  height: 100%;
  vertical-align: bottom;
}

.moving {
  cursor: grabbing;
}
`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/transcript/transcript.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,UAAU;EACV,oBAAoB;EACpB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".transcript-full-div {\n  width: 100%;\n  height: 100%;\n}\n\n.transcript-title-div,\n.transcript-search-div {\n  position: sticky;\n  z-index: 2;\n  justify-items: right;\n  padding: 5px;\n  display: none;\n}\n\n.transcript-title-div {\n  background-color: #404040;\n  text-align: center;\n}\n\n.transcript-title-div.title-active,\n.transcript-search-div.search-active {\n  display: block;\n}\n\n.transcript-top-div {\n  width: 100%;\n  height: calc(100% - 45px);\n  display: flex;\n}\n\n.transcript-full-div:has(.title-active) {\n  height: calc(100% - 32px);\n}\n.transcript-top-div.search-active {\n  height: calc(100% - 80px);\n}\n\n.transcript-full-div:has(.replace-active) .transcript-top-div.search-active {\n  height: calc(100% - 110px);\n}\n\n.transcript-text-div {\n  width: calc(100% - 20px);\n  height: 100%;\n  background-color: transparent;\n  cursor: text;\n  outline: none;\n}\n\n.transcript-scroll-div {\n  height: 99%;\n  width: 20px;\n}\n\n.transcript-bottom-div {\n  width: 100%;\n  height: 45px;\n  background-color: #404040;\n  border-top: 1px solid;\n  font-size: 90%;\n  align-content: center;\n  overflow: hidden;\n}\n\n.transcript-bottom-div .row {\n  display: flex;\n  flex-direction: row;\n}\n\n.transcript-bottom-div .row .col {\n  display: flex;\n  flex: 50%;\n}\n\n.transcript-bottom-div .row .col p:first-child {\n  padding: 0 5px;\n}\n\n.transcript-bottom-div .row .col:last-child {\n  justify-content: right;\n}\n\n.transcript-bottom-div p {\n  margin: 0;\n}\n\n.pl-5 {\n  padding-left: 5px;\n}\n\n.pr-5 {\n  padding-right: 5px;\n}\n\n.pink {\n  color: #ff9c9c;\n}\n\n.foreCanvas {\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n  cursor: text;\n}\n\ninput[type='range'][orient='vertical'] {\n  writing-mode: vertical-lr;\n  direction: ltr;\n  width: 16px;\n  height: 100%;\n  vertical-align: bottom;\n}\n\n.moving {\n  cursor: grabbing;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
